import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { take } from 'rxjs';
import { ApplicationUserAbstract } from '../../models/applicationUserAbstract';
import { AuthenticationService } from '../../services/AuthenticationService';
import { UserManagementApiService } from '../../services/UserManagementApiService';

@Component({ standalone: false,
  selector: 'verify-user-dialog',
  templateUrl: 'verify-user-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['verify-user-dialog.component.scss']
})
export class VerifyUserDialogComponent {
  public title: string= "Verify User";
  public confirmButtonText = "Confirm";
  public cancelButtonText = "Cancel";
  public busy:boolean=false;

  public user!:ApplicationUserAbstract;

  public decisionForm:FormGroup;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<VerifyUserDialogComponent>, private authService:AuthenticationService, private um_api:UserManagementApiService, public snackBar: MatSnackBar) {
    this.decisionForm = new FormGroup({
      verified: new FormControl<boolean>(false),
      reason: new FormControl<string|undefined>(undefined, Validators.compose([Validators.required, Validators.minLength(5)]))
    });
    if(data){
      this.user=data.user;
    }
  }

  get canVerify(){
    return this.decisionForm.valid && this.decisionForm.get("verified")!.value == true;
  }

  onConfirmClick(): void {
    this.busy=true;
    let remarks:any = {};
    remarks["user"] = this.authService.currentUserValue!.fullName;
    remarks["remarks"] = this.decisionForm.get("reason")!.value;
    this.um_api.verifyRegistrationManually(this.user!.id, JSON.stringify(remarks)).pipe(take(1)).subscribe(r =>{
      this.busy=false;
      if(r.success) {
        this.dialogRef.close(true);
        this.snackBar.open("User verified", '×', { panelClass: ['primary-snackbar'], verticalPosition: 'top', duration: 3000 });
      }
      else this.snackBar.open("Cannot verify user: " + r.message, '×', { panelClass: ['warn-snackbar'], verticalPosition: 'top' });
    });
  }

  onCancelClick():void{
    this.dialogRef.close(false);
  }
}